module.exports = __webpack_public_path__ + "static/media/controls_zh.8a87283d.png";